<template>
  <v-container
    fluid
    class="qa-form" pt-3>
    <v-btn @click="goToAttestationList" class="mb-4">
      <v-icon
        color="primary"
        class="mr-2">arrow_back</v-icon> Go back
    </v-btn>
    <material-card color="orange" title="Attestation">
      <!-- <div class="px-3">
          <v-layout row wrap>
              <v-flex
                  sm12
                  md6>
                  <v-layout align-center mb-4>
                      <v-flex md5>
                      <label>Account ID: <span class="required">*</span></label>
                      </v-flex>
                      <v-flex md9>
                      <v-text-field
                          hide-details
                          v-model="request.Acct_ID"
                          placeholder="Enter a value"
                          name="Account_ID"
                          solo
                      />
                      </v-flex>
                  </v-layout>
                  <v-layout align-center mb-4>
                      <v-flex md5>
                      <label>Account Owner: <span class="required">*</span></label>
                      </v-flex>
                      <v-flex md9>
                      <v-text-field
                          hide-details
                          v-model="request.Acct_Owner"
                          placeholder="Enter a value"
                          name="Account_Owner"
                          solo
                      />
                      </v-flex>
                  </v-layout>
                  <v-layout align-center mb-4>
                      <v-flex md5>
                      <label>WBS Code: <span class="required">*</span></label>
                      </v-flex>
                      <v-flex md9>
                      <v-text-field
                          hide-details
                          v-model="request.WBS_Code"
                          placeholder="Enter a value"
                          name="WBS_Code"
                          solo
                      />
                      </v-flex>
                  </v-layout>
                  <v-layout align-center mb-4>
                      <v-flex md5>
                      <label>Managed Services: <span class="required">*</span></label>
                      </v-flex>
                      <v-flex md9>
                          <v-select
                          hide-details
                          v-model="request.Managed_Services"
                          :items="['DXC Silver', 'DXC Gold', 'Amazon Managed Services', 'None (Customer Managed)']"
                          :menu-props="{ maxHeight: '400' }"
                          placeholder="Select a value"
                          attach
                          solo
                          clearable
                          />
                      </v-flex>
                  </v-layout>
              </v-flex>
              <v-flex sm12>
                  <v-layout row wrap align-center mb-4>
                      <v-flex sm12>
                      <label>Internal vs SaaS <span class="required">*</span></label>
                      </v-flex>
                      <v-flex sm12>
                          <v-layout 
                              column
                              align-start>
                              <v-flex>
                              <v-radio-group v-model="request.Internal_Vs_Saas">
                                  <v-radio
                                      color="primary"
                                      value="Internal"
                                      
                                  >
                                      <span slot="label" class="ml-2 black--text radioLabel">Is the AWS cloud environment used for DXC internal use only, such as hosting an internal DXC application or internal training account to which DXC clients do not have access?</span>
                                  </v-radio>
                                  <v-radio
                                      color="primary"
                                      value="SaaS"
                                  >
                                  <span slot="label" class="ml-2 black--text radioLabel">Is this account used for delivering a one or more differentiated solutions to the client which is built by DXC for the client?</span>
                                  </v-radio>
                              </v-radio-group>
                              </v-flex>
                          </v-layout>
                      </v-flex>
                  </v-layout>

                  <v-layout
                    v-if="request.Internal_Vs_Saas && request.Internal_Vs_Saas != 'Internal'"
                    align-center mb-4 row wrap>
                      <v-flex sm12>
                      <label>Direct VS Indirect console access <span class="required">*</span></label>
                      </v-flex>
                      <v-flex sm12>
                          <v-layout 
                              column
                              align-start>
                              <v-flex>
                              <v-radio-group v-model="request.Direct_Vs_Indirect_Access" >
                                  <v-radio
                                      color="primary"
                                      value="SPP"
                                  >
                                      <span slot="label" class="ml-2 black--text radioLabel">In the differentiated solution(s), does the client have access to the AWS console or to the AWS services directly? (SPP)</span>
                                  </v-radio>
                                  <v-radio
                                      color="primary"
                                      value="PPA"
                                  >
                                  <span slot="label" class="ml-2 black--text radioLabel">Does the client consume the services using the application layers without access to the AWS console and services? (PPA)</span>
                                  </v-radio>
                              </v-radio-group>
                              </v-flex>
                          </v-layout>
                      </v-flex>
                  </v-layout>

                  <v-layout 
                    v-if="request.Internal_Vs_Saas && request.Internal_Vs_Saas != 'Internal'"
                    align-center mb-4 row wrap>
                      <v-flex sm12>
                          <label>Does the AWS account contain any new workloads that were added to the account since the original account creation/ migration? Note: a "new workload workload" means a new application or web site or expansion to a new business<span class="required">*</span></label>
                      </v-flex>
                      <v-flex sm12>
                          <v-layout 
                              column
                              align-start>
                              <v-flex>
                              <v-radio-group v-model="request.New_Workload">
                                  <v-radio
                                      color="primary"
                                      value="Yes"
                                  >
                                      <span slot="label" class="ml-2 black--text radioLabel">Yes</span>
                                  </v-radio>
                                  <v-radio
                                      color="primary"
                                      value="No"
                                  >
                                  <span slot="label" class="ml-2 black--text radioLabel">No</span>
                                  </v-radio>
                              </v-radio-group>
                              </v-flex>
                          </v-layout>
                      </v-flex>
                  </v-layout>
              </v-flex>
              <v-flex
                  v-if="request.Internal_Vs_Saas && request.Internal_Vs_Saas != 'Internal' && request.New_Workload == 'Yes'"
                  sm12
                  md6>
                  <v-layout align-center mb-4>
                      <v-flex md3>
                      <label>SFDC ID: <span class="required">*</span></label>
                      </v-flex>
                      <v-flex md9>
                      <v-text-field
                          hide-details
                          v-model="request.SFDC_ID"
                          placeholder="Enter a value"
                          name="SFDC_ID"
                          solo
                      />
                      </v-flex>
                  </v-layout>
              </v-flex>
              <v-flex>
                  <v-layout
                    v-if="request.Internal_Vs_Saas && request.Internal_Vs_Saas != 'Internal'"
                    align-center mb-4 row wrap>
                      <v-flex sm12>
                          <label>What DXC services or solutions are being provided for the AWS account? Please describe or attach architecture diagram or SOW document</label>
                      </v-flex>
                      <v-flex sm12 mt-2>
                          <v-textarea
                          clearable
                          v-model="request.DXC_Services"
                          solo/>
                      </v-flex>
                  </v-layout>
                  <v-layout 
                    v-if="request.Internal_Vs_Saas && request.Internal_Vs_Saas != 'Internal'"
                    align-center mb-4 row wrap>
                      <v-flex sm12>
                          <label>Uploaded documents</label>
                      </v-flex>
                      <v-flex>
                        <div v-for="file in uploadedFiles">
                          <a href="javascript:void(0)" @click="downloadFile(file)">{{ file }}</a>
                        </div>
                          
                      </v-flex>
                  </v-layout>

                  <v-layout align-center mb-4 row wrap>
                      <v-flex sm12>
                          <label>Confirm Correctness of your statement<span class="required">*</span></label>
                      </v-flex>
                      <v-flex sm12>
                          <v-layout 
                              column
                              align-start>
                              <v-flex>
                              <v-radio-group v-model="request.Confirm_Correctness" >
                                  <v-radio
                                      color="primary"
                                      value="Yes"
                                  >
                                      <span slot="label" class="ml-2 black--text radioLabel">Yes</span>
                                  </v-radio>
                                  <v-radio
                                      color="primary"
                                      value="No"
                                  >
                                  <span slot="label" class="ml-2 black--text radioLabel">No</span>
                                  </v-radio>
                              </v-radio-group>
                              </v-flex>
                          </v-layout>
                      </v-flex>
                  </v-layout>
              </v-flex>
          </v-layout>
          <h4>Requestor</h4>
          <v-layout row wrap>
              <v-flex
              md6>
              <v-text-field
                  v-model="requestorName"
                  label="Requestor Name"
                  readonly
              />
              </v-flex>
              <v-flex
              md6>
              <v-text-field
                  v-model="requestorEmail"
                  label="Requestor Email"
                  readonly
              />
              </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md6>
              <v-select
                :items="['Pending','Rejected','Approved']"
                v-model="request.Status"
                attach
                label="Approval Status"
              />
              <v-btn class="success" @click="onSubmit" :loading="updatingRequest">Update Status</v-btn>
            </v-flex>
            <v-flex>
              <v-text-field
                  hide-details
                  v-model="updatedAt"
                  name="Date Updated"
                  label="Date Updated"
                  readonly
              />
            </v-flex>
          </v-layout>
      </div> -->
      <div class="px-3">
        <v-layout row wrap>
          <v-flex
            sm12
            md6>
            <v-layout align-center mb-4>
              <v-flex md5>
                <label>Account ID: <span class="required">*</span></label>
              </v-flex>
              <v-flex md9>
                <v-text-field
                  hide-details
                  v-model="request.Acct_ID"
                  placeholder="Enter a value"
                  name="Account_ID"
                  solo/>
              </v-flex>
            </v-layout>

            <v-layout align-center mb-4>
              <v-flex md5>
                <label>Account Owner: <span class="required">*</span></label>
              </v-flex>
              <v-flex md9>
                <v-text-field
                  hide-details
                  v-model="request.Acct_Owner"
                  placeholder="Enter a value"
                  name="Account_Owner"
                  solo
                />
              </v-flex>
            </v-layout>

            <v-layout align-center mb-4>
              <v-flex md5>
                <label>Financial Owner: <span class="required">*</span></label>
              </v-flex>
              <v-flex md9>
                <v-text-field
                  hide-details
                  v-model="request.Financial_Owner"
                  placeholder="Enter a value"
                  name="Financial_Owner"
                  solo/>
              </v-flex>
            </v-layout>

            <v-layout align-center mb-4>
              <v-flex md5>
                <label>WBS Code: <span class="required">*</span></label>
              </v-flex>
              <v-flex md9>
                <v-text-field
                  hide-details
                  v-model="request.WBS_Code"
                  placeholder="Enter a  WBS Code"
                  name="WBS_Code"
                  solo
                />
              </v-flex>
            </v-layout>

            <v-layout align-center mb-4>
              <v-flex md5>
                <label>Customer Name: <span class="required">*</span></label>
              </v-flex>
              <v-flex md9>
                <v-text-field
                  hide-details
                  v-model="request.Customer_Name"
                  placeholder="Enter a Customer Name"
                  name="Customer_Name"
                  solo
                />
              </v-flex>
            </v-layout>

            <v-layout align-center mb-4>
              <v-flex md5>
                <label>Managed Services: <span class="required">*</span></label>
              </v-flex>
              <v-flex md9>
                <v-select
                  :items="awsManagedServices"
                  v-model="request.Managed_Services"
                  :menu-props="{ maxHeight: '400' }"
                  placeholder="Select a value"
                  hide-details
                  attach
                  solo
                  clearable
                />
              </v-flex>
            </v-layout>

            <v-layout align-center mb-4>
              <v-flex md5>
                <label>Account Purpose: <span class="required">*</span></label>
              </v-flex>
              <v-flex md9>
                <v-select
                  v-model="request.Acct_Purpose"
                  :items="acctPurpose"
                  hide-details
                  placeholder="Select a value"
                  attach
                  solo
                  clearable
                />
              </v-flex>
            </v-layout>

          </v-flex>
          <v-flex
            sm12
            md12>

            <v-layout align-center mb-12 row wrap>
              <v-flex sm12>
                <label>Account Type</label>
              </v-flex>
              <v-flex sm12>
                <v-layout 
                  column
                  align-start>
                  <v-flex>
                    <v-radio-group v-model="request.Acct_Type" >
                      <v-radio
                        color="primary"
                        value="Internal"
                        class="mb-4">
                        <p slot="label" style="font-size: 20px !important" class="ml-2 mb-0 black--text radioLabel"><span class="font-weight-bold">Internal</span> - The AWS cloud environment is used for DXC internal use only, such as hosting an internal DXC application or internal training account, where <span class="font-weight-bold">no party outside DXC has access to the AWS environment.</span></p>
                      </v-radio>
                      <v-radio
                        color="primary"
                        value="Commercial"
                        class="mb-4">
                        <p slot="label" style="font-size: 20px !important" class="ml-2 mb-0 black--text radioLabel"><span class="font-weight-bold">Commercial</span> - The AWS cloud environment is used to provide services to the customers or partners outside of DXC.</p>
                      </v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout align-center mb-12 row wrap>
              <v-flex sm12>
                <label>Provided Commercial Service</label>
              </v-flex>
              <v-flex sm12>
                <v-layout 
                    column
                    align-start>
                    <v-flex>
                    <v-radio-group v-model="request.Provided_Commercial_Service" >
                        <v-radio
                            color="primary"
                            value="SaaS"
                            class="mb-4"
                        >
                            <p slot="label" style="font-size: 20px !important" class="ml-2 mb-0 black--text radioLabel"><span class="font-weight-bold">SaaS (Software as a Service)</span> - Software Services provided by DXC are charged to customers based on units of measure; such as the number of users , subscriptions, amount of data processing etc.</p>
                        </v-radio>
                        <v-radio
                            color="primary"
                            value="Differentiated Solution"
                            class="mb-4"
                        >
                        <p slot="label" style="font-size: 20px !important" class="ml-2 mb-0 black--text radioLabel"><span class="font-weight-bold">Differentiated Solution</span> - The AWS cloud environment is used to provide services to the customers or partners outside of DXC.</p>
                        </v-radio>
                        <v-radio
                            color="primary"
                            value="None of the above"
                            class="mb-4"
                        >
                            <p slot="label" style="font-size: 20px !important" class="ml-2 mb-0 black--text radioLabel"><span class="font-weight-bold">None of the above</span> - DXC hosts the client&apos;s AWS environment with any level of DXC provided managed services.  The Customer&apos;s AWS Account is under a DXC owned master payer.</p>
                        </v-radio>
                    </v-radio-group>
                    </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout align-center mb-4 row wrap>
              <v-flex sm12>
                <label>Customer Console Access</label>
              </v-flex>
              <v-flex sm12>
                <v-layout
                  column
                  align-start>
                  <v-flex>
                    <v-radio-group v-model="request.Customer_Console_Access" >
                      <v-radio
                        color="primary"
                        value="No Access"
                        class="mb-4"
                      >
                        <p slot="label" style="font-size: 20px !important" class="ml-2 mb-0 black--text radioLabel"><span class="font-weight-bold">No Access</span> - Client does not have access to the AWS account (Application access is allowed)</p>
                      </v-radio>
                      <v-radio
                        color="primary"
                        value="Read Access"
                        class="mb-4"
                      >
                        <p slot="label" style="font-size: 20px !important" class="ml-2 mb-0 black--text radioLabel"><span class="font-weight-bold">Read Only Access</span> - Client has access to AWS with Read Only permissions</p>
                      </v-radio>
                      <v-radio
                        color="primary"
                        value="Write Access"
                        class="mb-4"
                      >
                        <p slot="label" style="font-size: 20px !important" class="ml-2 mb-0 black--text radioLabel"><span class="font-weight-bold">Edit: Read & Write Access</span> - Client has elevated rights for editing the environment</p>
                      </v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <h4>Requestor</h4>
            <v-layout row wrap>
              <v-flex md6>
                <v-text-field
                  v-model="requestorName"
                  label="Requestor Name"
                  readonly
                />
              </v-flex>
              <v-flex md6>
                <v-text-field
                  v-model="requestorEmail"
                  label="Requestor Email"
                  readonly
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md6>
                <v-select
                  :items="['Pending','Rejected','Approved']"
                  v-model="request.Status"
                  attach
                  label="Approval Status"
                />
                <v-btn class="success" @click="onSubmit" :loading="updatingRequest">Update Status</v-btn>
              </v-flex>
              <v-flex>
                <v-text-field
                  hide-details
                  v-model="updatedAt"
                  name="Date Updated"
                  label="Date Updated"
                  readonly
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </material-card>
  </v-container>
</template>
  
<script>
// Utilities
import {
  mapMutations,
  mapState,
  mapActions
} from 'vuex'


import { convertUTCToLocal } from '@/utils/helper'

export default {
  data() {
    return {
      contractSignatureDateModal: false,
      showAccountModelDetails: false,
      showContractTypeDetails: false,
      acctPurpose:['PROD', 'STAGE', 'QA', 'DEV', 'TEST', 'POC', 'DEMO', 'SANDBOX', 'TRAINING', 'SERVICE ACCOUNT'],
      awsManagedServices: ['Internal', 'Silver non-managed', 'Silver CloudOps managed', 'Gold', 'Custom managed', 'No managed services', 'Amazon Managed Services (AMS)' ],

    }
  },
  mounted() {
    this.$store.dispatch('admin/accountAttestation/getAttestationRequest', this.$route.params.id)
  },
  computed: {
    ...mapState('admin/accountAttestation', ['submitting','request', 'updatingRequest']),
    requestorName() {
      return `${this.request.Requestor_First_Name} ${this.request.Requestor_Last_Name}`
    },
    requestorEmail() {
      return this.request.Requestor_Email
    },
    uploadedFiles() {
      return this.request.Architecture_Diagram.split(',')
    },
    updatedAt() {
      return convertUTCToLocal(this.request.Updated_At)
    }
  },
  methods: {
    ...mapActions({
      updateAttestation: 'admin/accountAttestation/updateAttestation'
    }),
    downloadFile(name) {
      console.log(name)
      this.$store.dispatch('admin/accountAttestation/downloadFile', name)
    },
    onSubmit() {
      let attestationData = {
        ...this.request
      }
      console.log('submitting form')
      this.updateAttestation(attestationData)
    },
    goToAttestationList() {
      this.$router.push({ path: '/admin/attestations/view-requests' })
    }
  },
}

</script>
<style lang="scss" scoped>
.dash {
  position: relative;
  padding-bottom:100px;
  top: 25%;
}

.qa-form {
  font-size: 20px;
  .radioLabel {
      font-size: 20px;
      line-height: normal;
  }
  .v-btn-toggle{ margin:10px 0}
  .v-btn-toggle .v-btn{
    padding: 15px 38px;
    opacity: 1;
  }
  
  .btn--qa{
    font-weight: bold !important;
  }

  .v-select--width{
    width: 100%;
  }

  span{
    &.workload-desc{
      font-weight:600
    }
  }

  div {
    &.qa-desc{
      font-style: italic;
      font-size: 14px;
    }
  }
}
</style>
